// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__IQZqI","label":"Labeled_label__MUYSW","divider":"Labeled_divider__2jB0P"};